import type { CSSProperties, ReactNode } from 'react';

import { css } from '@sorare/css';

const anchor = css`
  position: relative;
  flex: none;
  line-height: 0;
`;

const dot = css`
  position: absolute;
  right: 0;
  bottom: 0;
  width: var(--unit);
  height: var(--unit);
  border-radius: var(--unit);
  background: var(--status-color);
  box-shadow: 0 0 0 calc(var(--half-unit) / 2) var(--status-ring-color);
`;

type Props = {
  available: boolean;
  ringColor?: string;
  children: ReactNode;
};

export const WithCompetitionStatusDot = ({
  available,
  ringColor = 'var(--c-black)',
  children,
}: Props) => (
  <span className={anchor}>
    {children}
    <span
      className={dot}
      style={
        {
          '--status-color': available
            ? 'var(--c-score-high)'
            : 'var(--c-red-400)',
          '--status-ring-color': ringColor,
        } as CSSProperties
      }
    />
  </span>
);
